export const providePhoneConstraints = (translateKey1: string, translateKey2: string, translateKey3: string): { [key: string]: any } => {
  return {
    phone: {
      presence: {
        allowEmpty: false,
        message: translateKey3
      },
      format: {
        pattern: '^[5].*',
        flags: 'i',
        message: translateKey1,
      },
      length: {
        minimum: 9,
        maximum: 9,
        message: translateKey2
      },
    },
  };

};

export const provideEmailConstraints = (translateKey1: string,  translateKey2: string): { [key: string]: any } => {
  return {
    email: {
      presence: {
        allowEmpty: false,
        message: translateKey2
      },
      format: {
        pattern: '^[a-zA-Z0-9._%+-]+@(orinabiji\\.ge|step2\\.ge)$',
        flags: 'i',
        message: translateKey1,
      }
    },
  };

};